import IntegrationBase from 'eflex/models/integration-base';

export default class IntegrationOutbox extends IntegrationBase {}
